import { Box, Breadcrumbs, Dialog, MenuItem, TextField } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
import { Group, Panel as PanelRRP, Separator } from 'react-resizable-panels';

import { Title } from '../../../styles';

export const CardContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '24px',
  marginTop: '32px',
}));

export const StyledBreadcrumbs = styled(Breadcrumbs)(() => ({}));

export const StyledTitle = styled(Title)(() => ({
  marginTop: '24px',
  textTransform: 'unset',

  '& .arrow-forward-ios': {
    fontSize: '16px',
    color: '#2E383F',
  },
}));

export const Section = styled('section')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  margin: '32px 0',

  '& .values': {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
}));

export const ContainerGroup = styled(Group)(() => ({
  containerType: 'inline-size',
  '& #left': {
    '& .MuiGrid-root': {
      overflow: 'auto',
      scrollbarWidth: 'none',
      '-ms-overflow-style': 'none',

      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
  },
}));

export const Panel = styled(PanelRRP)(() => ({
  borderRadius: '8px 0 0 8px',
  background: '#FFF',
  boxShadow: '-2px 0 53.3px 0 rgba(0, 0, 0, 0.05)',
  position: 'relative',
}));

export const StyledSeparator = styled(Separator)(() => ({
  width: '4px',
  cursor: 'col-resize',
}));

export const DelegatedSessionsContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 12,
}));

export const CompanySelect = styled(TextField)(({ theme }) => ({
  padding: '0px 8px',

  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: 500,
    color: theme.palette.secondary.main,

    '& fieldset': {
      border: 'none',
    },

    '& .MuiSelect-icon': {
      color: theme.palette.secondary.main,
    },
  },
}));

export const CompanyMenuItem = styled(MenuItem)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '8px',

  '&:hover': {
    backgroundColor: alpha(theme.palette.secondary.main, 0.08),
  },

  '&.Mui-selected': {
    backgroundColor: 'transparent',
  },

  '&.Mui-selected:hover': {
    backgroundColor: alpha(theme.palette.secondary.main, 0.08),
  },

  '& .material-symbols-outlined': {
    fontSize: '18px',
    color: '#475467',
  },
}));

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: '16px',
    backgroundColor: theme.palette.common.white,
    maxWidth: 'none',
  },
  '& .MuiDialog-paperScrollPaper': {
    '&::-webkit-scrollbar': {
      width: '10px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.primary.dark,
      borderRadius: '10px',
      '&:hover': {
        backgroundColor: theme.palette.primary.main,
      },
    },
    '&::-webkit-scrollbar-track': {
      margin: '60px 0',
    },
  },
}));
